function CohablistTerms() {
  return (
    <div style={{ maxWidth: 720, margin: '60px auto', padding: '0 24px 80px', fontFamily: 'inherit', lineHeight: 1.7, color: '#222' }}>
      <h1 style={{ fontSize: '1.6rem', marginBottom: 4 }}>Cohablist — Terms of Service</h1>
      <p style={{ color: '#666', marginTop: 0, marginBottom: 32 }}>Last updated: August 2026</p>

      <p>
        By using Cohablist ("the App"), you agree to these terms. If you do not agree, do not use the App.
      </p>

      <h2>Use of the App</h2>
      <p>
        The App is provided for personal, non-commercial use by small groups of people sharing a home.
        You must be at least 13 years old to use the App.
      </p>

      <h2>Your account</h2>
      <p>
        You sign in using your Google or Apple account. You are responsible for keeping your account secure.
        You are responsible for all activity that occurs under your account.
      </p>

      <h2>Your content</h2>
      <p>
        You own the content you create in the App (shopping lists, chores, events). By using the App,
        you grant us the right to store and display that content to the members of your household group.
        We do not use your content for any other purpose.
      </p>

      <h2>Cohablist Premium (subscriptions)</h2>
      <p>
        Cohablist offers an optional auto-renewing subscription, "Cohablist Premium," which unlocks additional
        features for your household (such as more household members, more lists, and expanded avatar options).
        Premium is purchased through the Apple App Store or Google Play Store and managed using RevenueCat.
      </p>
      <ul>
        <li>Subscriptions are billed monthly or yearly, at the price shown in the App at the time of purchase, in your local currency as set by the App Store or Play Store.</li>
        <li>Payment is charged to your Apple ID or Google Play account at confirmation of purchase.</li>
        <li>Subscriptions automatically renew for the same period and price unless auto-renewal is turned off at least 24 hours before the end of the current period.</li>
        <li>Your account will be charged for renewal within 24 hours prior to the end of the current period.</li>
        <li>You can manage or cancel your subscription at any time in your Apple ID or Google Play account settings — we cannot cancel it for you, as Apple/Google process the transaction directly.</li>
        <li>Refunds are handled by Apple or Google under their own refund policies. You may also submit a refund request to us in-app, but we cannot directly issue refunds — Apple/Google process payments, not us.</li>
        <li>If Premium was granted via a promotional code instead of a paid purchase, the above billing terms do not apply; the code's terms (e.g. duration, redemption limits) are as described where the code was offered.</li>
        <li>Premium unlocks additional functionality but does not transfer ownership of App features; we may adjust what Premium includes over time, with notice via an update to these terms.</li>
      </ul>

      <h2>Acceptable use</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Use the App for any unlawful purpose</li>
        <li>Attempt to gain unauthorised access to other users' data</li>
        <li>Interfere with or disrupt the App's operation</li>
      </ul>

      <h2>Availability</h2>
      <p>
        We provide the App on a best-effort basis. We may suspend, modify, or discontinue the App at any
        time without notice. We are not liable for any loss resulting from unavailability of the App.
      </p>

      <h2>Disclaimer of warranties</h2>
      <p>
        The App is provided "as is" without warranties of any kind, express or implied. We do not
        guarantee that the App will be error-free or uninterrupted.
      </p>

      <h2>Limitation of liability</h2>
      <p>
        To the fullest extent permitted by law, we are not liable for any indirect, incidental, or
        consequential damages arising from your use of the App.
      </p>

      <h2>Governing law</h2>
      <p>
        These terms are governed by the laws of England and Wales.
      </p>

      <h2>Changes</h2>
      <p>
        We may update these terms at any time. The "Last updated" date above will reflect the most recent
        change. Continued use of the App after a change constitutes acceptance of the updated terms.
      </p>

      <h2>Contact</h2>
      <p>
        Questions about these terms:&nbsp;
        <a href="mailto:dennis.hvel@gmail.com">dennis.hvel@gmail.com</a>
      </p>
    </div>
  );
}

export default CohablistTerms;
